export default "__VITE_ASSET__DrTRMicV__"